import { useCallback } from "react";
import { Barcode, NfcCard, Occupancy, Platform } from "@variocube/app-api";
import { useBarcodeListener, useCardListener } from "@variocube/cube-ui";
import { Delivery, DeliveryState, getOccupancyDeliveries } from "./types";

export function useKeyInput(onKey: (key: string) => void) {
    const handleBarcode = useCallback((barcode: Barcode) => onKey(barcode.code), [onKey]);
    useBarcodeListener(handleBarcode);

    const handleCard = useCallback((card?: NfcCard) => card && onKey(card.uid), [onKey]);
    useCardListener(handleCard);
}

export function findByStorageKey(deliveries: Delivery[], storageKey: string) {
    return deliveries.find(delivery => (delivery.storage.storageKey == storageKey || delivery.storage.storageCode == storageKey));
}

export async function findByPickupKey(platform: Platform, pickupKey: string, deliveriesStorage: Delivery[]) {
    const occupancies = await platform.getOccupancies();
    return occupancies.filter(occupancy => hasRecipientPickupKey(occupancy, pickupKey, deliveriesStorage));
}

function hasRecipientPickupKey(occupancy: Occupancy, pickupKey: string, deliveriesStorage: Delivery[]) {
    if (occupancy.accessCode == pickupKey) {
        console.log(`Pickup key ${pickupKey} matched for accessCode`);
        return true;
    }
    const deliveries = getOccupancyDeliveries(occupancy); 

    if (deliveries) {
        for (const delivery of deliveries) {
            if (isStoredAndHasRecipientPickupKeyInDelivery(delivery, pickupKey)) {
                return true;
            }

            //check additionaly the delivery storage items as they might be more recent after update in logisticss
            const deliveryStorageItem = deliveriesStorage.find(d => d.delivery.deliveryId === delivery.delivery.deliveryId);
            if (deliveryStorageItem) {
                const foundRecipient = isStoredAndHasRecipientPickupKeyInDelivery(deliveryStorageItem, pickupKey);
                if (foundRecipient) return foundRecipient;
            }
        }
    }
    return undefined;
}

function isStoredAndHasRecipientPickupKeyInDelivery(delivery: Delivery, pickupKey: string) {
    if (
        delivery?.delivery.state === DeliveryState.Stored
        && delivery?.recipients.length > 0
    ) {
        const recipient = delivery.recipients.filter((r) => r.pickupKey == pickupKey).pop();
        return recipient; 
    }
    return undefined;
}